import { css } from 'react-emotion'

export const calendarContainer = css`
  .react-datepicker {
    border: none;
    border-radius: 0.5rem;
  }

  .react-datepicker__month-container {
    background-color: #353535;
    float: left;
    padding: 0.8rem;
    border-radius: 0.4rem;
    font-size: 1.2rem;
  }
  .react-datepicker__triangle {
    display: none;
  }

  .react-datepicker__header {
    background-color: #353535;
    color: #ffffff;
    border: none;
  }

  .react-datepicker__month {
    background-color: #353535;
    color: #ffffff;
    margin: 0;
  }

  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle,
  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::before {
    display: none;
  }

  .react-datepicker__current-month,
  .react-datepicker-time__header,
  .react-datepicker-year-header {
    display: none;
  }

  .react-datepicker__navigation--previous,
  .react-datepicker__navigation--next {
    display: none;
  }

  .react-datepicker__navigation {
    width: 0px;
  }

  .react-datepicker__day-name,
  .react-datepicker__day,
  .react-datepicker__time-name {
    color: #969696;
    margin: 4px;
    &:hover {
      color: #1f1f1f;
    }
  }

  .react-datepicker__header__dropdown react-datepicker__header__dropdown--scroll {
    display: flex;
  }

  .react-datepicker__day,
  .react-datepicker__month-text,
  .react-datepicker__quarter-text {
    color: #ffffff;
  }

  react-datepicker__day react-datepicker__day--031 react-datepicker__day--outside-month {
    color: #ffffff1a;
  }

  .react-datepicker__year-dropdown,
  .react-datepicker__month-dropdown,
  .react-datepicker__month-year-dropdown {
    color: #ffff;
    background-color: #353535;
    width: 100%;
    left: 0;
  }

  .react-datepicker__year-option,
  .react-datepicker__month-option,
  .react-datepicker__month-year-option {
    &:hover {
      background-color: #1d1f21;
    }
  }

  .react-datepicker__year-option:first-of-type,
  .react-datepicker__month-option:first-of-type,
  .react-datepicker__month-year-option:first-of-type {
    &:hover {
      background-color: #1d1f21;
    }
  }

  .react-datepicker__month-dropdown-container--scroll {
    border: 1px solid #707070;
    padding: 0.8rem 3.4rem 0.8rem 0rem;
    display: inline-block;
    vertical-align: middle;
    margin-right: 0.5rem;
    position: absolute;
    width: 25%;
    left: 0;
  }

  .react-datepicker__year-dropdown-container--scroll {
    border: 1px solid #707070;
    display: inline-block;
    vertical-align: middle;
    position: relative;
    margin-left: 5rem;
    padding: 0.8rem 1.4rem 0.8rem 0rem;
  }

  .react-datepicker__day-names,
  .react-datepicker__week {
    font-size: 12px;
  }

  .react-datepicker__month-read-view--down-arrow {
    top: 3px;
    left: 30px;
  }

  .react-datepicker__year-read-view--down-arrow {
    top: 3px;
    left: 9px;
  }

  .react-datepicker__month-read-view {
    text-align: left;
    margin-left: 8px;
  }

  .react-datepicker__year-read-view {
    text-align: left;
    margin-left: 8px;
  }

  .react-datepicker__day--outside-month {
    color: #ffffff1a;
  }

  .react-datepicker__year-option--selected,
  .react-datepicker__month-option--selected {
    left: 5px;
  }

  .react-datepicker__year-dropdown,
  .react-datepicker__month-dropdown,
  .react-datepicker__month-year-dropdown {
    top: 0px;
  }

  .react-datepicker__day--keyboard-selected {
    background-color: #1f93ff;
    padding: 0.5rem;
  }

  .react-datepicker__day--selected {
    background-color: #1f93ff;
    padding: 0.5rem;
  }

  .react-datepicker__day-name,
  .react-datepicker__day,
  .react-datepicker__time-name {
    padding: 0.5rem;
  }

  .react-datepicker__year-dropdown--scrollable,
  .react-datepicker__month-dropdown--scrollable,
  .react-datepicker__month-year-dropdown--scrollable {
    height: 255px;
  }
`
